import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { RoleManagementService } from '@services/role.management.service';
import { toHTML } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { PromptRequests, ResponsesRequests } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { ItemsSubPartEditorComponent } from '../items-sub-part-editor/items-sub-part-editor.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import Adapter from '../ckeditorAdapter';

@Component({
  selector: 'app-items-match-order-match-list',
  templateUrl: './items-match-order-match-list.component.html',
  styleUrls: ['./items-match-order-match-list.component.scss']
})
export class ItemsMatchOrderMatchListComponent implements OnInit {
  @Output() postCreated = new EventEmitter();
  // questionEditor: Editor = new Editor();
  display: boolean = false;
  ckeditorConfig = CkeditorConfig;
  isCkeditorLoading: boolean = true;
  matchOrderForm: FormGroup;
  itemId: string;
  questionId: string;
  isQuestionAdded: boolean = false;
  validateQuestion: boolean = false;
  isEditMode: boolean = false;
  isListMode: boolean = false;
  private routerSubscription: Subscription;
  // promtEditor: Editor = new Editor();
  // optionEditor: Editor = new Editor();
  promtToDelete: any[] = [];
  responseToDelete: any[] = [];
  promtNewArray: any[] = [];
  QuestionScoringType: any;
  reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    description: 'description',
    tempPromt: 'tempPromt',
    tempResponse: 'tempResponse',
    responsesRequests: 'responsesRequests',
    promptRequests: 'promptRequests',
    correctPoints: 'correctPoints',
    itemId: 'itemId',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch',
    options: 'options'
  }
  @ViewChild("myEditor1") myEditor1: any;
  @ViewChild("myEditor2") myEditor2: any;
  @ViewChild("myEditor3") myEditor3: any;
  public Editor: any = Editor;
  errorMessage;
  errorMessagePrompt;
  errorMessageResponse;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;  public uploadedFileNames = [];
  public uploadedFileOptions = [];
  QuestionImages = []
  promptImages = []
  responsesImages = []
  imageId: number = 1;
  constructor(
    public roleSer: RoleManagementService,
    private router: Router,
    public dialog: MatDialog,
    private routerstate: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private itemservice: ItemService,
    private notificationService: NotificationService,
    private questionService: QuestionService,
    private webErrorService: WebErrorService,
    private translate: TranslateService
  ) {
    this.routerSubscription = this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });

    this.questionId = sessionStorage.getItem(this.reuseProp.questionuuId);
    if (!this.questionId) {
      this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId;
    }

    this.matchOrderForm = new FormGroup({
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.MatchOrder),
      questionTypeId: new FormControl(QuestionTypeIdEnum.MatchOrder),
      questiondisplayoptions: new FormControl('Vertical'),
      active: new FormControl(true),
      autoScoring: new FormControl(true),
      allowCheckAnswer: new FormControl(false),
      shuffleOption: new FormControl(false),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl('true'),
      [this.reuseProp.questiondescription]: new FormGroup({ description: new FormControl('', Validators.required), mediaURL: new FormControl([""]), file_name: new FormControl([""]) }),
      [this.reuseProp.itemId]: new FormControl(),
      [this.reuseProp.correctPoints]: new FormControl(0),
      [this.reuseProp.promptRequests]: new FormArray([],[Validators.required, Validators.minLength(2)]),
      [this.reuseProp.responsesRequests]: new FormArray([],[Validators.required, Validators.minLength(2)]),
      [this.reuseProp.penaltyPoints]: new FormControl(0),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0,Validators.required),
      [this.reuseProp.options]: new FormArray([]),

      [this.reuseProp.tempPromt]: new FormControl(),
      [this.reuseProp.tempResponse]: new FormControl(),
      questionImages: new FormControl(''),
      promptImages: new FormControl(''),
      responsesImages: new FormControl('')
    });

    this.questionService.getQuestionScoringType().subscribe(d => {this.QuestionScoringType = d.data})
  }

  get f() {
    return this.matchOrderForm.controls;
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onReadyPrompt(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessagePrompt = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessagePrompt = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessagePrompt = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileOptions.push(res.fileName)
        this.promptImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onReadyResponse(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessageResponse = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessageResponse = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessageResponse = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileOptions.push(res.fileName)
        this.responsesImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  ngOnInit(): void {
    if (this.questionId) {
      this.isEditMode = true;
      const questionServiceGetSubscription: Subscription = this.questionService
        .getQuestion(this.itemId, this.questionId)
        .subscribe((resdata) => {
          this.isQuestionAdded = true;
          this.matchOrderForm.patchValue(resdata.data);
          this.matchOrderForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.stringify(resdata.data.scoringTypeExactMatch));
          if (resdata.data.responses && resdata.data.responses.length) {
            resdata.data.responses.forEach(element => {
              (<FormArray>this.matchOrderForm.controls[this.reuseProp.responsesRequests]).push(new FormControl(element));
            });
          };
          if (resdata.data.prompts && resdata.data.prompts.length) {
            resdata.data.prompts.forEach(element => {
              (<FormArray>this.matchOrderForm.controls[this.reuseProp.promptRequests]).push(new FormControl({
                ...element, modified: true,
                resValue: element.correctresponseid && element.correctresponseid !== 0 ?
                  resdata.data.responses.find(o => o.responseid === element.correctresponseid).responsedescription.description : ''
              }));
            });
          };
          resdata.data.prompts.forEach(ele => {
            resdata.data.responses = resdata.data.responses.filter(d => d.responseid !== ele.correctresponseid);
          });
          resdata.data.responses.forEach(e => {
            if (e.responsedescription !== null) {
              this.promtNewArray.push({
                correctresponseid: e.responseid,
                resValue: e.responsedescription.description
              });
            }
          });
          this.matchOrderForm.get(this.reuseProp.promptRequests).updateValueAndValidity();
          questionServiceGetSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

  replace2Decimal(event: any, o, type: any){
    let value = event.target.value;
    if (event.key == '.')value = value + event.key;
    var ponto = value.split('.').length;
    var slash = value.split('-').length;
    if (ponto > 2)
    value=value.substr(0,(value.length)-1);

    if(slash > 2)
    value=value.substr(0,(value.length)-1);

    value=value.replace(/[^0-9.-]/,'');

    if (ponto ==2)
    value=value.substr(0,(value.indexOf('.')+3));

    if(value == '.')
    value = "";

    if (type == 'options') o.correctpoints = parseFloat(value);
    if (type == 'minimumScore') {
      let num = value.substr(value.length - 1);
      if (num != '.' && value != '') this.matchOrderForm.controls[this.reuseProp.minScoreIfAttempt].setValue(parseFloat(value))
    }
    // if (type == 'minimumScore') this.matchOrderForm.controls[this.reuseProp.minScoreIfAttempt].setValue(parseFloat(value))
  }

  validateInput(event, o?, type?) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,4}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]
    console.log('value',value)
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      if(type == 'options') o.correctPoints = parseFloat(inputElement.value );
      if(type == 'minimumScore') this.matchOrderForm.controls[this.reuseProp.minScoreIfAttempt].setValue(parseFloat(inputElement.value))
      if(beforeDecimal.length == 5 && afterDecimal.length > 1){
        inputElement.value = ''
        if(type == 'options') o.correctPoints = 0;
        if(type == 'minimumScore') this.matchOrderForm.controls[this.reuseProp.minScoreIfAttempt].setValue(0)
      }
    }
  }

  validateAndSetQuestion(): void {
    let question = this.matchOrderForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description];
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();

    this.isQuestionAdded = this.validateEditorText(question1);
    this.validateQuestion = this.isQuestionAdded === false;
  }

  validateEditorText(value: string): boolean {
    return value.length != 0;
  }

  validateAndAddPromt(): void {
    this.matchOrderForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description] = this.matchOrderForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description]
    // .replace(/<img/g, '<img width="auto" height="auto"')
    let questionHtml = this.matchOrderForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description];
    if (!questionHtml || questionHtml.length === 0) {
      this.isQuestionAdded = false;
      this.validateQuestion = true;
    } else {
      this.errorMessagePrompt = false;
      this.isQuestionAdded = true;
      this.validateQuestion = false;
      let newValue = this.matchOrderForm.controls[this.reuseProp.tempPromt].value.replace(/&nbsp;/g,'').trim();
      // .replace(/<img/g, '<img width="auto" height="auto"');
      let question1 = newValue;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();

      // if (newValue.type) { newValue = toHTML(newValue); }
      if (this.validateEditorText(question1)) {
        let existingValue = this.matchOrderForm.controls[this.reuseProp.promptRequests].value;
        let newPromt: PromptRequests = {
          promptdescription: {
            description: newValue, mediaURL: [''], file_name: this.uploadedFileOptions
          }, correctpoints: 0, correctresponseid: 0, promptid: 1, modified: false,
          arrangeOrderforPrompts: 0,
          resValue: ''
        };
        if (existingValue && existingValue.length) {
          this.matchOrderForm.controls[this.reuseProp.promptRequests].patchValue(existingValue);
          newPromt = { ...newPromt, promptid: existingValue[existingValue.length - 1].promptid + 1 };
        }
        (<FormArray>this.matchOrderForm.controls[this.reuseProp.promptRequests]).push(new FormControl(newPromt));
        this.setAndUpdateControl(this.reuseProp.tempPromt, '');
        this.uploadedFileOptions = []
        // this.promtEditor.setContent('');
      }
    }
  }

  validateAndAddResponse() {
    let questionHtml = this.matchOrderForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description];
    if (!questionHtml || questionHtml.length === 0) {
      this.isQuestionAdded = false;
      this.validateQuestion = true;
    } else {
      this.errorMessageResponse = false;
      this.isQuestionAdded = true;
      this.validateQuestion = false;
      let newValue = this.matchOrderForm.controls[this.reuseProp.tempResponse].value
      .replace(/&nbsp;/g,'').trim()
      // .replace(/<img/g, '<img width="auto" height="auto"');
      let question1 = newValue;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();

      if (newValue.type) { newValue = toHTML(newValue); }
      if (this.validateEditorText(question1)) {
        let existingValue = this.matchOrderForm.controls[this.reuseProp.responsesRequests].value;
        let newOpt: ResponsesRequests = {
          responsedescription: { description: newValue, mediaURL: [''], file_name: this.uploadedFileOptions }, modified: false, responseid: 1,
          arrangeOrderforresponses: 0
        };

        if (existingValue && existingValue.length) {
          newOpt = { ...newOpt, responseid: existingValue[existingValue.length - 1].responseid + 1, arrangeOrderforresponses: existingValue.length + 1 };
        }
        (<FormArray>this.matchOrderForm.controls[this.reuseProp.responsesRequests]).push(new FormControl(newOpt));
        this.getResponseData(newOpt);
        this.setAndUpdateControl(this.reuseProp.tempResponse, '');
        this.uploadedFileOptions = []
        // this.optionEditor.setContent('');
      }
    }
  }

  getResponseData(newOpt: any) {
    this.promtNewArray.push({
      resValue: newOpt.responsedescription.description,
      correctresponseid: newOpt.responseid
    })
  }

  calculateScore(): void {
    this.matchOrderForm.get(this.reuseProp.correctPoints).patchValue(parseFloat((<FormArray>this.matchOrderForm.controls[this.reuseProp.promptRequests]).value.map(d => d.correctpoints).reduce((a, b) => +a + +b)).toFixed(2));
    this.matchOrderForm.get(this.reuseProp.correctPoints).updateValueAndValidity();
  }

  setAndUpdateControl(controlName: string, value: any): void {
    this.matchOrderForm.get(controlName).patchValue(value);
    this.matchOrderForm.get(controlName).updateValueAndValidity();
  }

  back(): void {
    this.postCreated.emit('false');
    this.display = true;
    // this.questionEditor.destroy();
  }

  saveMatchOrderQuestion() {
    this.setAndUpdateControl(this.reuseProp.itemId, JSON.parse(sessionStorage.getItem(this.reuseProp.itemId)));
    this.matchOrderForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(this.matchOrderForm.controls[this.reuseProp.scoringTypeExactMatch].value);
    let question = this.matchOrderForm.value.questiondescription['description'];
    this.matchOrderForm.value.questiondescription['file_name'] = this.uploadedFileNames;
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();
    if (question1.length == 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.DragAndDrop.errMsg1'), true, 'warn')
      return;
    }

    if (this.QuestionImages.length > 0) {
      this.QuestionImages.forEach(ele => {

        question1 = question1.replace(ele.base64, ele.uniqueId)

        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }
    this.matchOrderForm.value.questiondescription['description'] = question1;
    this.matchOrderForm.value.questionImages = this.QuestionImages;

    if (this.promptImages.length > 0) {
      this.promptImages.forEach(ele => {
        this.matchOrderForm.value.promptRequests.forEach(option => {
          option.promptdescription.description = option.promptdescription.description.replace(ele.base64, ele.uniqueId)
          option.resValue = option.resValue.replace(ele.base64, ele.uniqueId)
        })
        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }

    this.matchOrderForm.value.promptImages = this.promptImages;

    if (this.responsesImages.length > 0) {
      this.responsesImages.forEach(ele => {
        this.matchOrderForm.value.responsesRequests.forEach(option => {
          option.responsedescription.description = option.responsedescription.description.replace(ele.base64, ele.uniqueId)
        })
        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }

    this.matchOrderForm.value.responseImages = this.responsesImages;

    if (this.isEditMode) {
      let isCorrectPoints = this.matchOrderForm.value.promptRequests.find(s => s.correctpoints == "");
      if (isCorrectPoints) {
        this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg8'), true, 'warn')
        return;
      }
      const questionServiceUpdateSubscription: Subscription = this.questionService.updateQuestion(this.matchOrderForm.value, this.itemId, this.questionId).subscribe(
        (resData) => {
          this.responseToDelete.forEach(d => this.questionService.deleteResponse(this.questionId, d.responseid, d.matchOrderId).subscribe(data => { }));
          this.promtToDelete.forEach(ele => this.questionService.deletePrompt(this.questionId, ele.promptid, ele.matchOrderId).subscribe(data => { }));
          this.itemservice.editedGetItem(resData.data);
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isListMode = true;
          questionServiceUpdateSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
    else {
      if (this.matchOrderForm.value.correctPoints < 0) {
        this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.DragAndDrop.errMsg2'), true, 'warn')
        return;
      } else {
        const questionServicePostSubscription: Subscription = this.questionService.addQuestion(this.matchOrderForm.value, this.itemId).subscribe(
          (resData) => {
            this.isEditMode = true;
            this.notificationService.success(resData?.message);
            // this.itemservice.questionCountUpdate.next(true);
            // this.questionService.reloadList.next(true);
            this.isEditMode = true;
            this.isListMode = true;
            questionServicePostSubscription.unsubscribe()
          },
          (error) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });
      }
    }
  }

  openDialog(value: any, isPromt: boolean): void {
    const dialogSubscription = this.dialog.open(ItemsSubPartEditorComponent,
      { width: '950px', height: '350px', panelClass: 'option-dialog', data: { value: isPromt ? value.promptdescription.description : value.responsedescription.description, title: isPromt ? this.translate.instant('questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.Prompt') : this.translate.instant('questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.Respose') } })
      .afterClosed().subscribe((result) => {
        if (result) {
          this.itemservice.getfileName.subscribe(file => {
            if (isPromt) {
              const index = this.matchOrderForm.controls[this.reuseProp.promptRequests].value.findIndex((d: any) => d.promptid == value.promptid)
              this.matchOrderForm.controls[this.reuseProp.promptRequests].value[index].promptdescription = { description: result, mediaURL: [''], file_name: file};

              // (<FormArray>this.matchOrderForm.controls[this.reuseProp.promptRequests])
              //   .at(this.matchOrderForm.controls[this.reuseProp.promptRequests].value.findIndex((d: any) => d.promptid == value.promptid))
              //   .setValue({ ...value, promptdescription: { description: result, mediaURL: [''], } });
              // this.matchOrderForm.get(this.reuseProp.promptRequests).updateValueAndValidity();
            }
            else {
              (<FormArray>this.matchOrderForm.controls[this.reuseProp.responsesRequests])
                .at(this.matchOrderForm.controls[this.reuseProp.responsesRequests].value.findIndex((d: any) => d.responseid == value.responseid))
                .setValue({ ...value, responsedescription: { description: result, mediaURL: [''], file_name: file} });
              // this.matchOrderForm.get(this.reuseProp.responsesRequests).updateValueAndValidity();
              const resVal = this.matchOrderForm.controls[this.reuseProp.promptRequests].value.filter(d => d.correctresponseid === value.responseid);

              if (resVal.length !== 0 && resVal[0].resValue !== '') {
                // (<FormArray>this.matchOrderForm.controls[this.reuseProp.promptRequests]).at(this.matchOrderForm.controls[this.reuseProp.promptRequests].value.findIndex((d: any) => d.correctresponseid == value.responseid)).setValue({ ...resVal[0], resValue: result });
                const index = this.matchOrderForm.controls[this.reuseProp.promptRequests].value.findIndex((d: any) => d.correctresponseid == value.responseid)
                // this.matchOrderForm.controls[this.reuseProp.promptRequests].value[data].setValue({resValue:result} );
                this.matchOrderForm.controls[this.reuseProp.promptRequests].value[index].resValue = result;
                // this.matchOrderForm.get(this.reuseProp.promptRequests).updateValueAndValidity();
              }
              else {
                this.promtNewArray.filter((d: any) => d.correctresponseid === value.responseid).forEach(e => e.resValue = result);
                // this.matchOrderForm.get(this.reuseProp.promptRequests).updateValueAndValidity();
              }
            }
          })
        }
        dialogSubscription.unsubscribe();
      });
  }

  removeArrayItem(index: number, property: any): void {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: property === this.reuseProp.promptRequests ? this.translate.instant('questions.typeOfQuestions.DragAndDrop.deletePopup.message') + property.slice(0, -8) + '?' : this.translate.instant('questions.typeOfQuestions.DragAndDrop.deletePopup.message') + property.slice(0, -9) + '?',
        buttonText: {
          ok: this.translate.instant('questions.typeOfQuestions.DragAndDrop.deletePopup.btnYes'),
          cancel: this.translate.instant('questions.typeOfQuestions.DragAndDrop.deletePopup.btnNo'),
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        if (property === this.reuseProp.promptRequests) {
          this.promtToDelete.push({
            promptid: (<FormArray>this.matchOrderForm.get(property)).at(index).value.promptid,
            matchOrderId: (<FormArray>this.matchOrderForm.get(property)).at(index).value.matchOrderId
          });
        } else {
          this.responseToDelete.push({
            responseid: (<FormArray>this.matchOrderForm.get(property)).at(index).value.responseid,
            matchOrderId: (<FormArray>this.matchOrderForm.get(property)).at(index).value.matchOrderId
          });
          if (this.promtNewArray && this.promtNewArray.length) {
            const deleteResponse = this.promtNewArray.find(d => d.correctresponseid === (<FormArray>this.matchOrderForm.get(property)).at(index).value.responseid);
            this.promtNewArray = this.promtNewArray.filter(item => item !== deleteResponse);
          }
          if (this.matchOrderForm.controls[this.reuseProp.promptRequests].value.find(d => d.correctresponseid ===
            (<FormArray>this.matchOrderForm.get(property)).at(index).value.responseid)) {
            const resIndex = this.matchOrderForm.controls[this.reuseProp.promptRequests].value.findIndex(d => d.correctresponseid ===
              (<FormArray>this.matchOrderForm.get(property)).at(index).value.responseid);
            this.matchOrderForm.controls[this.reuseProp.promptRequests].value[resIndex].correctresponseid = 0;
            this.matchOrderForm.controls[this.reuseProp.promptRequests].value[resIndex].resValue = '';
          }
        }
        (<FormArray>this.matchOrderForm.get(property)).removeAt(index);
        this.matchOrderForm.get(property).updateValueAndValidity();
      }
    })
  }

  dropMain(event: any) {
    const dataToReplace = JSON.parse(JSON.stringify(this.matchOrderForm.controls[this.reuseProp.promptRequests].value[event.currentIndex]));
    this.matchOrderForm.controls[this.reuseProp.promptRequests].value.forEach((d, index) => {
      if (index === event.currentIndex && this.matchOrderForm.controls[this.reuseProp.promptRequests].value[index].resValue !== '' && !event.item.data.promptid) {
        this.promtNewArray.push({
          resValue: this.matchOrderForm.controls[this.reuseProp.promptRequests].value[index].resValue,
          correctresponseid: this.matchOrderForm.controls[this.reuseProp.promptRequests].value[index].correctresponseid
        });
      }
    });

    this.matchOrderForm.controls[this.reuseProp.promptRequests].value[event.currentIndex] = {
      ...this.matchOrderForm.controls[this.reuseProp.promptRequests].value[event.currentIndex],
      correctresponseid: event.item.data.correctresponseid, resValue: event.item.data.resValue
    };
    if (event.item.data.promptid &&
      event.item.data.promptid !== 0) {
      this.matchOrderForm.controls[this.reuseProp.promptRequests].value[event.previousIndex] =
        { ...this.matchOrderForm.controls[this.reuseProp.promptRequests].value[event.previousIndex], correctresponseid: dataToReplace.correctresponseid, resValue: dataToReplace.resValue };
    }
    if (this.promtNewArray.length) {
      this.promtNewArray = this.promtNewArray.filter(d => d.correctresponseid !== event.item.data.correctresponseid);
    }
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
